import { ConditionalTooltipWrapper } from 'components/Tooltip';
import React from 'react';

const InsightItem: React.FC<{
  label: string;
  value: number;
  isLast?: boolean;
  tooltip?: React.ReactNode;
}> = ({ label, value, isLast = false, tooltip }) => (
  <ConditionalTooltipWrapper tooltip={tooltip}>
    <div
      className={`flex-grow-0 flex-shrink-0 border-right ${
        isLast ? '' : 'mr-2 pr-2'
      }`}
      style={{
        minWidth: '120px',
        borderColor: '#dee2e6',
        cursor: 'default',
        ...(isLast && { borderRight: 'none' }), // Remove border for the last item
      }}
    >
      <div className="text-center">
        <h6
          className="mb-0"
          style={{ whiteSpace: 'nowrap', display: 'inline-block' }}
        >
          {label}
        </h6>

        <h5 className="font-weight-bold mb-0">{value}</h5>
      </div>
    </div>
  </ConditionalTooltipWrapper>
);

export default InsightItem;
